define('GridOrder.Button.View', [
    'GridOrder.Confirmation.View',
    'SCView',
    'grid_order_button.tpl',
    'jQuery',
    'underscore'
], function (
    GridOrderConfirmationView,
    SCViewComponent,
    grid_order_button_tpl,
    jQuery,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function GridOrderButtonView(options) {
        var _this = this;

        SCView.call(this);

        _this.options = options || {};

        _this.template = grid_order_button_tpl;

        _this.attributes = { 
            id: 'GridOrder.Button.View', 'class': 'grid-order-button-view' 
        }

        let userProfile = _this.options.user;

        _this.contextDataRequest = ['item'];

        userProfile.getUserProfile().done(function (profile) {
            _this.userProfile = profile;
        })
    }

    GridOrderButtonView.prototype = Object.create(SCView.prototype);

    GridOrderButtonView.prototype.constructor = GridOrderButtonView;

    GridOrderButtonView.prototype.getEvents = function getEvents() {
        return {
            'click [data-action="grid-order-add-to-cart"]': 'addToCart'
        };
    };

    GridOrderButtonView.prototype.addToCart = function addToCart() {
        let _this = this;
        let container = _this.options.container;
        let cart = container.getComponent('Cart');
        let lines = _this.getLines();

        if (cart && lines.length) {
            cart.addLines({ lines: lines }).done(function afterAddToCart(cartData) {
                let layout = container.getComponent('Layout');
                let confirmationView = new GridOrderConfirmationView({
                    itemCount: lines.reduce(function sum(subtotal, line) {
                        return subtotal + Number(line.quantity);
                    }, 0)
                });

                // Reset items to be added into the cart
                _this.removeLines();
                // children.val('')

                // Re-render list
                try {
                    container.getLayout().getCurrentView().render();
                } catch (e) {
                    console.log('GridOrder.Button.View', e);
                }

                confirmationView.modalClass = 'added-to-cart-modal';

                // Show confirmation modal
                layout.showContent(confirmationView, {
                    showInModal: true
                });
            });
        }
    },

    GridOrderButtonView.prototype.getChildViews = function getChildViews() {
        return {
            'GridOrderConfirmation.View,': function() {
                return new GridOrderConfirmationView();
            }
        };
    }

    GridOrderButtonView.prototype.getLines = function getLines() {
        this.lines = SC.SESSION ? SC.SESSION.multiGridOrder || {} : {};

        this.lines = _(this.lines).reject(function eachLine(line) {
            return Number(line.quantity) === 0;
        });

        return this.lines;
    }

    GridOrderButtonView.prototype.removeLines = function removeLines() {
        if (SC.SESSION) {
            SC.SESSION.multiGridOrder = this.lines = {};
        }
    }

    GridOrderButtonView.prototype.disableGridOrder = function disableGridOrder() {
        //We've got to disable loginToSeePrices feature if customer registration is disabled.
        let _this = this;
        let configuration = _this.options.container.getComponent('Environment');
        let getRegistrationType = (configuration.getSiteSetting('requireloginforpricing', 'F') === 'T' ||
        configuration.getSiteSetting('siteloginrequired', 'F') === 'T')
        return getRegistrationType && _this.userProfile.isloggedin === true;
    },

    GridOrderButtonView.prototype.getContext = function getContext() {
        var _this = this;
        var lines = _this.getLines();
        
        // console.log('disableGridOrder', _this.disableGridOrder())

        return {
            isEnabled: !_this.disableGridOrder(),
            lines: lines,
            itemCount: lines.reduce(function sum(subtotal, line) {
                return subtotal + Number(line.quantity);
            }, 0)
        };
    }

    return GridOrderButtonView;
});
